import type { SxProps } from "@mui/system";
import {
  selectMultiSelectRankBorder,
  selectMultiSelectRankContainerStyle,
  choiceGroupHeadingStyle,
} from "../CommonStyles/commonStyle";
import type { ThemeV2 } from "../../../util/types";

export const chipWrapper = (
  isLandScapeMode: boolean,
  theme: ThemeV2,
  isStyleList: boolean,
): SxProps => ({
  display: "flex",
  width: "100%",
  flexWrap: "wrap",
  height: "100%",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  ...(isStyleList
    ? {
        ...selectMultiSelectRankBorder(
          isLandScapeMode,
          theme.tokens.color.action.primary,
          theme.tokens.color.surface.card,
          theme.tokens.shape.radius.md,
        ),
        justifyContent: "start",
        alignItems: "start",
        flexDirection: "column",
        gap: `${theme.tokens.spacing["2"]}px`,
        width: "100%",
        minWidth: "100%",
        padding: `${theme.tokens.spacing["4"]}px`,
      }
    : selectMultiSelectRankContainerStyle(isLandScapeMode)),
  ...choiceGroupHeadingStyle(isLandScapeMode, isStyleList, theme),
});
